module.exports = __webpack_public_path__ + "static/media/PierSans-BoldItalic.1786f732.otf";